
export type DbToObject = (dto: object) => object;

export class DataMapper {
	constructor(
		public name: string,
		public dbToObject: DbToObject,
	) { }

	data: object | null = null;
}

export class PageInfo {
	constructor(
		public id: number | null,
		public name: string,
		public path: string,
		public storeModule: string | null,
		public storeObject: string | null,
		public props: object,
		public loadData: boolean = false,
		public refresh: boolean = false,
	) { }

	dataMapper: DataMapper | null = null;
}

export class PageManager {
	pages: PageInfo[] = [];
}

export const state = new PageManager();
